














import { Component, Vue, Watch } from "vue-property-decorator";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";

import HealthProfessionalModal from "./HealthProfessionalModal.vue";
import userModel from "@/models/user.model";

@Component({
	components: {
		PaginatedSearch,
		HealthProfessionalModal,
	},
})
class HealthProfessionals extends Vue {
	entityModel: any;
	userId: string = "";

	constructor() {
		super();
		this.entityModel = userModel;
	}

	async mounted() {
		this.userId = this.$route.params.id;
	}

	openEntity(user: any) {
		this.$router.push(`/escalas/profissionais-saude/${user.id}`);
	}

	closeModal() {
		this.$router.push(".");
		(this.$refs.paginatedSearch as any).refresh();
	}

	@Watch("$route")
	updateRoute(route: any) {
		if (route.params.id) {
			this.userId = route.params.id;
		} else {
			this.userId = "";
		}
	}
}

export default HealthProfessionals;
